import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Grid, Column, Row, Button, cls } from '../../packages/components';
import { ColoredButton } from '../../packages/components/lib/ColoredButton';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import Device from '../../devices/device';

import './styles/calendarPhase.scss';
class AAFModalMundialCalendarioFase extends Component {

    constructor(props) {
        super(props);
        this.keys = Device.getDevice().getKeys();
    }

    componentDidMount = () => {
        const {round} = this.props;
        this.setDefaultFocus(round);
        this.addListener();
    }

    componentWillUnmount = () => {
        this.removeListener();
    }

    addListener = () => {
        document.removeEventListener('keydown', this.handleKey, true);
        document.addEventListener('keydown', this.handleKey, true);
    }

    removeListener = () => {
        document.removeEventListener('keydown', this.handleKey, true);
    }

    setDefaultFocus = (round) => {
        window.SpatialNavigation.focus(`.modal-body a#${round}.aaf_button.focusable`);
    }

    onFocus = (index) => {
      const indexTarget = this.props.options.length - 3;

        const [body, ...rest] = document.getElementsByClassName('modal-body');
        const increment = 140;

        if (index === indexTarget && body){
          body.scrollTop = body.scrollTop + increment;
        }
    }

    handleKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

        switch (currentKey) {
            case 'YELLOW':
                const {handleBack} = this.props;
                e.preventDefault();
                e.stopPropagation();
                handleBack();
            break;
            default:
            break;
        }
    }

    render (){
        const {device, options, handleClose, handleSelectOption, handleBack} = this.props;
        const p = {
            alwaysEnabled: true,
            buttonsAlign: 'horizontal',
            aafNewStyle: true,
            className: 'aaf-modal mundial-calendar',
            showLogo: false,
        };
        return (
            <ModalWrapper {...p}>
            <Grid className={device}>
                <Row className='modal-header'>
                    <Column>
                        <ColoredButton color={'yellow'}
                            className={cls(`modal_worldcup_schedule_back`,`focusable`)}
                            onClick= {handleBack}
                            imgSrc = {Asset.get('top_head_option_back', '')}
                            >{Translator.get('top_head_option_button_return','REGRESAR')}
                        </ColoredButton>
                    </Column>

                </Row>
                <Row className='modal-body'>
                    {options.map((option, index) => {
                        return (
                            <Column lg={12}>
                                <Button
                                    id={option.id}
                                    activate
                                    type="button"
                                    className={cls('focusable')}
                                    onClick= {(e) => {
                                        handleSelectOption(option, () => {handleClose(e)});
                                    }}
                                    onFocus={() => this.onFocus(index)}
                                    >
                                    {option.name}
                                </Button>
                            </Column>
                        );
                    })}
                </Row>
            </Grid>
            </ModalWrapper>
        );
    }
}


AAFModalMundialCalendarioFase.propTypes = {
    handleSelectOption: PropTypes.func,
    handleBack: PropTypes.func,
};

export default withOnClose(AAFModalMundialCalendarioFase);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalMundialCalendarioFase.jsx